module.exports = "/assets/1b9b53f9b99203e86a2c56910d22bc8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TA.png
// module id = 2969
// module chunks = 0